import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Navigate, generatePath } from 'react-router-dom';
import { LoadingOverlay } from '@/Components/shared';
import { useUserContext } from '@/Context/UserContext';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import RoutePath from '@/Routing/RoutePath';

function ProvisionPage() {
    const { isLoading } = useUserSignupNavigationContext();
    const { user } = useAuth0();
    const { tryProvisionAccount, provisioningInProcess } = useUserContext();

    useEffect(() => {
        const doTryProvisionAccount = async () => await tryProvisionAccount();
        doTryProvisionAccount();
    }, []);

    if (isLoading || provisioningInProcess) {
        return <LoadingOverlay />;
    }

    if (!user?.email_verified) {
        return <Navigate to={RoutePath.VerifyEmail} />;
    }

    return <Navigate to={generatePath(RoutePath.Root)} state={{ skipToRecruitmentOverview: true }} />;
}

export default ProvisionPage;
